module.exports = __webpack_public_path__ + "img/undraw_cancel_re_pkdm.c04de2b0.svg";